import {isBrowser} from "../components/_common/_constants";

export const getFlowId = () => {
  const search = isBrowser() ? window.location.search : undefined;
  const searchParams = new URLSearchParams(search);
  return Object.fromEntries(searchParams.entries()).flowId;
};
